import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { formatNumber, Location } from '@angular/common';
import { AuthService } from '../account/auth.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AppService } from 'src/app/shared/services/app.service';

@Component({
    selector: 'app-select-tenant',
    templateUrl: './select-tenant.component.html',
    styleUrls: ['./select-tenant.component.scss'],
    standalone: false
})
export class SelectTenantComponent implements OnInit {
  isLoading: boolean = true;
  UnknownTenant: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private globalService: GlobalService,
    private router: Router, 
    private route: ActivatedRoute,
    private authService: AuthService,
    private tenantService: TenantService,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.isLoading = false; 
    }

  async onSubmit(form: NgForm) { 
    if (!form.valid || form.value.churchId.trim() == '') {
      return;
    }

    var tenant = form.value.churchId.toLowerCase().trim();

    if (await this.tenantService.tenantExists(tenant) == false)
    {
      this.UnknownTenant = true;
      return;  
    }

    this.isLoading = true;
    this.clearAllCache();
    this.authService.logout(0);
    localStorage.setItem('tenant', tenant);
    let userId = localStorage.getItem('CSBarCideID');
    if (userId == null)
      userId = '';
    this.appService.sendToNative(userId, tenant);
    let currentUrl = this.document.location.origin.toLowerCase().replace(this.globalService.subdomain.toLowerCase(), 
    'main') + '/' + tenant.toLowerCase() + '/home';
    this.globalService.subdomain = tenant;
    location.href = currentUrl;
  }
  clearAllCache()
  {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName);
      });
    });
  }
}
